import { render, staticRenderFns } from "./deletedAccounts.vue?vue&type=template&id=1ddbeb46&scoped=true"
import script from "./deletedAccounts.vue?vue&type=script&lang=js"
export * from "./deletedAccounts.vue?vue&type=script&lang=js"
import style0 from "./deletedAccounts.vue?vue&type=style&index=0&id=1ddbeb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbeb46",
  null
  
)

export default component.exports